import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cache from '@/utils/cache'
import C from '@/config'
import router from '@/router'

export const useLayoutStore = defineStore('layout', () => {
    // 是否是移动端
    const ismobile = ref(false)
    // 菜单是否折叠 toggle
    const menuIsCollapse = ref(Cache.get('menuIsCollapse') || false)
    // 多标签栏
    const layoutTags = ref(Cache.get('layoutTags') || true)
    // 布局
    const layout = ref(Cache.get('layout') || C.Layout)

    // 头部路由标签
    const tagRouteList = ref([])
    // 是否刷新路由
    const routerView = ref(true)
    const keepLiveRoute = ref([])
    const routeKey = ref(null)
    const routeShow = ref(true)

    const pushViewTags = (route) => {
        let backPathIndex = tagRouteList.value.findIndex(item => item.fullPath === router.options.history.state.back)
        let target = tagRouteList.value.find((item) => item.fullPath === route.fullPath)
        let isName = route.name
        if (!target && isName) {
            if (backPathIndex === -1) {
                tagRouteList.value.push(route)
            } else {
                tagRouteList.value.splice(backPathIndex + 1, 0, route)
            }
        }
    }
    const removeViewTags = (route) => {
        tagRouteList.value.forEach((item, index) => {
            if (item.fullPath === route.fullPath) {
                tagRouteList.value.splice(index, 1)
            }
        })
    }
    const updateViewTags = (route) => {
        tagRouteList.value.forEach((item) => {
            if (item.fullPath === route.fullPath) {
                item = Object.assign(item, route)
            }
        })
    }
    const updateViewTagsTitle = (title = '') => {
        const nowFullPath = location.hash.substring(1)
        tagRouteList.value.forEach((item) => {
            if (item.fullPath === nowFullPath) {
                item.meta.title = title
            }
        })
    }
    const clearViewTags = () => {
        tagRouteList.value = []
    }
    const pushKeepLive = (component) => {
        if (!keepLiveRoute.value.includes(component)) {
            keepLiveRoute.value.push(component)
        }
    }
    const removeKeepLive = (component) => {
        let index = keepLiveRoute.value.indexOf(component)
        if (index !== -1) {
            keepLiveRoute.value.splice(index, 1)
        }
    }
    const clearKeepLive = () => {
        keepLiveRoute.value = []
    }
    const setRouteKey = (key) => {
        routeKey.value = key
    }
    const setRouteShow = (key) => {
        routeShow.value = key
    }

    return {
        ismobile,
        menuIsCollapse,
        layoutTags,
        layout,
        tagRouteList,
        routerView,
        keepLiveRoute,
        routeKey,
        routeShow,

        pushViewTags,
        removeViewTags,
        updateViewTags,
        updateViewTagsTitle,
        clearViewTags,
        pushKeepLive,
        removeKeepLive,
        clearKeepLive,
        setRouteKey,
        setRouteShow
    }
})
